import { Box, Typography } from "@mui/material";

export default function SectionTitle({ icon, title, description, right }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: { xs: "stretch", sm: "center" },
        justifyContent: "space-between",
        gap: 1.2,
        flexDirection: { xs: "column", sm: "row" },
        mb: 1.2,
        minWidth: 0,
      }}
    >
      <Box
        sx={{ display: "flex", gap: 1.2, alignItems: "center", minWidth: 0 }}
      >
        <Box
          sx={(theme) => ({
            width: 42,
            height: 42,
            borderRadius: 3,
            display: "grid",
            placeItems: "center",
            background:
              theme.palette.mode === "dark"
                ? "rgba(25,118,210,0.10)"
                : "rgba(255,255,255,0.72)",
            border: "1px solid rgba(25,118,210,0.22)",
            boxShadow:
              theme.palette.mode === "dark"
                ? "none"
                : "0 10px 26px rgba(0,0,0,0.08)",
            color: "primary.main",
            "& svg": { fontSize: 22, display: "block" },
            flexShrink: 0,
          })}
        >
          {icon}
        </Box>

        <Box sx={{ minWidth: 0 }}>
          <Typography
            sx={{ fontWeight: 950, fontSize: 18, lineHeight: 1.15 }}
            noWrap
          >
            {title}
          </Typography>
          {description ? (
            <Typography
              variant="body2"
              sx={{
                opacity: 0.7,
                overflowWrap: "anywhere",
                wordBreak: "break-word",
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: { xs: 2, sm: 1 },
                overflow: "hidden",
              }}
            >
              {description}
            </Typography>
          ) : null}
        </Box>
      </Box>

      {right ? (
        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>{right}</Box>
      ) : null}
    </Box>
  );
}
